import { Component, OnInit } from '@angular/core';
import { SuperAdminWorker, SuperAdminService } from '../services.service';


@Component({
  selector: 'app-superadmin-workers',
  templateUrl: './superadmin-workers.component.html',
  styleUrls: ['./superadmin-workers.component.css']
})
export class SuperadminWorkersComponent implements OnInit {

  workers:       SuperAdminWorker[] = [];
  filtered:      SuperAdminWorker[] = [];
  pagedWorkers:  SuperAdminWorker[] = [];

  loading = true;

  searchQuery    = '';
  selectedCompany = '';
  statusFilter: 'all' | 'active' | 'inactive' = 'all';

  // Pagination
  currentPage  = 1;
  pageSize     = 15;
  totalPages   = 1;
  pageNumbers: number[] = [];

  Math = Math;

  private avatarColors = [
    'linear-gradient(135deg, #1A1A2E, #2BB0A6)',
    'linear-gradient(135deg, #2BB0A6, #1F8F88)',
    'linear-gradient(135deg, #3498DB, #1A1A2E)',
    'linear-gradient(135deg, #E8A838, #C8891A)',
    'linear-gradient(135deg, #2ECC71, #1A9E4C)',
    'linear-gradient(135deg, #9B59B6, #6C3483)',
    'linear-gradient(135deg, #E74C3C, #C0392B)',
    'linear-gradient(135deg, #1ABC9C, #148F77)',
  ];

  constructor(private superAdminService: SuperAdminService) {}

  ngOnInit(): void {
    this.loadWorkers();
  }

  loadWorkers(): void {
    this.loading = true;
    this.superAdminService.getAllWorkers().subscribe({
      next: data => {
        this.workers = data;
        this.applyFilter();
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }

  // ── Filter ────────────────────────────────────────────────

  applyFilter(): void {
    let result = [...this.workers];

    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      result = result.filter(w =>
        w.fullName.toLowerCase().includes(q)    ||
        w.email.toLowerCase().includes(q)        ||
        w.companyName?.toLowerCase().includes(q)
      );
    }

    if (this.selectedCompany) {
      result = result.filter(w => w.companyName === this.selectedCompany);
    }

    if (this.statusFilter === 'active') {
      result = result.filter(w => w.isActive);
    } else if (this.statusFilter === 'inactive') {
      result = result.filter(w => !w.isActive);
    }

    this.filtered    = result;
    this.currentPage = 1;
    this.buildPagination();
    this.updatePage();
  }

  // ── Pagination ────────────────────────────────────────────

  buildPagination(): void {
    this.totalPages  = Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
    this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1)
      .filter(p => Math.abs(p - this.currentPage) <= 2);
  }

  updatePage(): void {
    const start       = (this.currentPage - 1) * this.pageSize;
    this.pagedWorkers = this.filtered.slice(start, start + this.pageSize);
    this.buildPagination();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePage();
  }

  // ── Computed ──────────────────────────────────────────────

  get activeCount(): number {
    return this.workers.filter(w => w.isActive).length;
  }

  get inactiveCount(): number {
    return this.workers.filter(w => !w.isActive).length;
  }

  get companyNames(): string[] {
    return [...new Set(
      this.workers
        .map(w => w.companyName)
        .filter((n): n is string => !!n)
    )].sort();
  }

  // ── Helpers ───────────────────────────────────────────────

  getInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    return parts.length >= 2
      ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      : name.slice(0, 2).toUpperCase();
  }

  getAvatarColor(id: string): string {
    const code = id?.charCodeAt(0) ?? 0;
    return this.avatarColors[code % this.avatarColors.length];
  }
}